import React from "react";
import Banner from "./Banner";
import Footer from "./Footer";

import img1 from "../gallery/img1.jpg";
import img2 from "../gallery/img2.jpg";
import img3 from "../gallery/img3.jpg";
import img4 from "../gallery/img4.jpg";
import img5 from "../gallery/img5.jpg";
import img6 from "../gallery/img6.jpg";
import img7 from "../gallery/img7.jpg";
import img8 from "../gallery/img8.jpg";
import img9 from "../gallery/img9.jpg";

const Photo = () => {
  return (
    <>
      <Banner />

      <div className="gallery_photo">
        <div className="photo_row">
          <div className="gallery_photo_img">
            <img src={img1} alt="not" />
          </div>
          <div className="gallery_photo_img">
            <img src={img2} alt="not" />
          </div>
          <div className="gallery_photo_img">
            <img src={img3} alt="not" />
          </div>
        </div>
        <div className="photo_row">
          <div className="gallery_photo_img">
            <img src={img4} alt="not" />
          </div>
          <div className="gallery_photo_img">
            <img src={img5} alt="not" />
          </div>
          <div className="gallery_photo_img">
            <img src={img6} alt="not" />
          </div>
        </div>
        <div className="photo_row">
          <div className="gallery_photo_img">
            <img src={img7} alt="not" />
          </div>
          <div className="gallery_photo_img">
            <img src={img8} alt="not" />
          </div>
          <div className="gallery_photo_img">
            <img src={img9} alt="not" />
          </div>
        </div>
      </div>

      <div className="tab_gallery_photo">
        <div className="tab_photo_row">
          <div className="tab_gallery_photo_img">
            <img src={img1} alt="not" />
          </div>
          <div className="tab_gallery_photo_img">
            <img src={img2} alt="not" />
          </div>
        </div>

        <div className="tab_photo_row">
          <div className="tab_gallery_photo_img">
            <img src={img3} alt="not" />
          </div>
          <div className="tab_gallery_photo_img">
            <img src={img4} alt="not" />
          </div>
        </div>

        <div className="tab_photo_row">
          <div className="tab_gallery_photo_img">
            <img src={img5} alt="not" />
          </div>
          <div className="tab_gallery_photo_img">
            <img src={img6} alt="not" />
          </div>
        </div>

        <div className="tab_photo_row">
          <div className="tab_gallery_photo_img">
            <img src={img7} alt="not" />
          </div>
          <div className="tab_gallery_photo_img">
            <img src={img8} alt="not" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Photo;
